import type { IconProps } from '../types/IconProps.ts';
export const SmilePlus: IconProps = {
    name: 'SmilePlus',
    children: [
        `<path d="M21.95 11q.05.5.05 1a10 10 0 1 1-9-9.95" />`,
        `<path d="M7 15a6.14 6.14 0 0 0 10 0M8 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M19 2v6M16 5h6" />`,
    ]
};